<template>
    <div class="video-one-component"
        :class="{'video-one-component-active' : status}"
        @click="clickVideo()"
        :style="{
            width: width,
            height: height
        }"
    >   
        <div class="video-one-component__image"
            :style="{ 
                backgroundImage: `url(${imgLocal})`,
                backgroundPosition: 'center center', 
                backgroundSize: 'cover'
            }"
        >

        </div>
        <div class="video-one-component__text" v-if="textStatus">
            {{text}}
        </div>
        <div class="video-one-component__timecode"
            v-if="timecode"
        >
            {{durationString }}
        </div>
    </div>
</template>

<script>
    export default {
        props: {
            index: {
                default: false
            },
            id: {
                default: false
            },
            text: {
                default: false
            },
            img: {
                default: false
            },
            width: {
                default: false
            },
            height: {
                default: false
            },
            status: {
                default: false
            },
            textStatus: {
                default: false
            },
            duration: {
                default: false
            },
            timecode: {
                default: false
            },
            video: {
                default: false
            },
            type: {
                default: false
            },
            control: {
                default: false
            },
            descr: {
                default: false
            },
            webm: {
                default: false
            },
            coef: {
                default: false
            }
        },
        computed: {
            imgLocal() {
                try {
                  if(this.img) {
                    if(this.img.indexOf('http') === 0) {
                      return this.img
                    } else if(this.img === 'text-icon.png') {
                      return require('~/assets/text-icon.png')
                    } else {
                      return require('~/assets/not-image.svg')
                    }
                  } else {
                    return require('~/assets/not-image.svg')
                  }
                } catch(e) {
                  console.error(e)
                  return false
                }
            },
            durationString() {
                if(this.duration) {
                    let num = this.duration;
                    let m;
                    let s;

                    if(num < 60) {
                        m = 0
                        s = num

                        if(s >= 10) {
                            return `00.${s}`
                        } else {
                            return `00.0${s}`
                        }
                    } else {

                        let minuteFraction = num / 60 

                        m = Math.trunc(minuteFraction)

                        let step_1 = m * 60
                        let step_2 = num - step_1

                        s = step_2
                        
                        if(m < 10) {
                            if(s >= 10) {
                                return `0${m}.${s}`
                            } else if (s < 60){
                                return `0${m}.0${s}`
                            }
                        } else {
                            if(s >= 10) {
                                return `${m}.${s}`
                            } else if (s < 60) {
                                return `${m}.0${s}`
                            }
                        }
                    }

                } else {
                    return false
                }
            }
        },
        methods: {
            async clickVideo() {
                this.$emit('clickVideo', {
                    index: this.index,
                    id: this.id,
                    text: this.text,
                    img: this.img,
                    status: this.status,
                    duration: this.duration,
                    timecode: this.timecode,
                    video: this.video,
                    type: this.type,
                    control: this.control,
                    descr: this.descr,
                    webm: this.webm,
                    coef: this.coef
                })
            }
        }
    }
</script>

<style lang="less">
    .video-one-component {
        border-radius: 5px;
        display: flex;
        justify-content: center;
        align-items: center;
        position: relative;
        cursor: pointer;
        overflow: hidden;
        margin-bottom: 5px;
    }

    .video-one-component-active {
        box-shadow: 0px 0px 4px rgba(255, 255, 255, 0.4), 0px 0px 10px rgba(143, 0, 255, 0.8);
    }

    .video-one-component__image {
        width: 100%;
        height: 100%;
        z-index: 5;
    }

    @import '~/assets/fonts/roboto/Roboto-Light.less';

    .video-one-component__text,
    .video-one-component__timecode {
        font-family: 'Roboto-Light';
        font-weight: 300;
        font-size: 13px;
        line-height: 20px;
        color: #FFFFFF;
        position: absolute;
        bottom: 0px;
        left: 7px;
        z-index: 5;
    }

    .video-one-component__timecode {
        left: inherit;
        right: 7px;
        font-size: 10px;
    }
</style>